import { classNames } from '@schuelerhilfe/shared/src/utils/classNames';
import type { CardSectionResolved } from './types';
import { SlotRenderer } from '@/components/SlotRenderer';
import { useCollapseWhenEmpty } from '@/lib/render/collapseWhenEmpty';
import { getSectionColorClass } from '@/lib/section-colors';

export const CardSectionComponent = ({
  resolved,
}: {
  resolved: CardSectionResolved;
}) => {
  const { background, hideOnMobile, blocks } = resolved;
  const collapseWhenEmpty = useCollapseWhenEmpty();

  return (
    // Two boxes on purpose: the outer one carries the inter-widget rhythm
    // (`pt-4`, top only — see the spacing convention in CLAUDE.md), the inner
    // one keeps the card's own `p-6` chrome. They cannot share an
    // element, because a `pt-*` utility would override the card's own top
    // padding and push the content against the card's top edge.
    <div
      className={classNames(
        // The card is a box *inside* the content column, so its edges line up
        // with the text of the widgets above and below it. It used to span the
        // column itself (`lg:max-w-6xl` with no gutter), which left it 36px
        // wider than its neighbours on each side (70.14-Widget-Width).
        'mx-auto max-w-6xl px-4 pt-4 lg:px-9',
        // On the spacing box, not the card: an empty card takes its own
        // pt-4 down with it — see `globals.css`.
        collapseWhenEmpty,
        hideOnMobile && 'hidden md:block',
      )}
    >
      <div
        className={classNames(
          'rounded-[var(--border-radius-section)] p-6',
          getSectionColorClass(background),
        )}
      >
        <SlotRenderer blocks={blocks} zoneName="blocks" />
      </div>
    </div>
  );
};
